import React from 'react';
import { useForm } from '../../ObservableForm';
import { GridChoiceFieldFragment } from './GridChoiceField.generated';
import BoxSelectField from './BoxSelectField';
import { PriceGuide } from '../../PriceGuide';
import { CurrencyCode } from '@99designs/i18n';

export type Props = GridChoiceFieldFragment;

export function Edit({ label, id, options, required, columns, subtext, footnote }: Props) {
    const form = useForm();

    return (
        <BoxSelectField
            form={form}
            name={id}
            title={label}
            required={required as boolean}
            options={options.map(({ label: optionLabel, value, subtext, price, image }) => {
                return {
                    label:
                        price && price.length > 0 ? (
                            <PriceGuide min={price[0] as number} currency={CurrencyCode.USD} />
                        ) : (
                            subtext
                        ),
                    title: optionLabel,
                    value: value,
                    image,
                };
            })}
            columns={columns}
            subtext={subtext}
            footnote={footnote}
        />
    );
}

export function View({ options, choiceValue }: Props) {
    const option = options.find((o) => o.value === choiceValue);
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{option?.label}</>;
}

export function HasValue({ choiceValue }: Props): boolean {
    return choiceValue !== '';
}

export function getValue({ choiceValue }: Props) {
    return choiceValue;
}
